import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { FAQS } from '../../lib/site';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../fx/Reveal';
export function FAQSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="relative mx-auto max-w-3xl px-6 py-24" data-id="element-237" data-mp="1wppzkro45sgb">
      <SectionHeading eyebrow="FAQ" title="Answers, Before You Ask" subtitle="Everything you need to know about working with Dream Shield." data-id="element-238" data-mp="18yu15bp5jz03" />
      <div className="mt-12 space-y-4" data-id="element-239" data-mp="1ixtdp5d1gesd">
        {FAQS.map((faq, i) => {
        const isOpen = open === i;
        return <Reveal key={faq.q} delay={i * 0.06} data-id="element-240" data-mp="1dygnqbqverlk" data-mpi={i}>
              <div className={`gradient-border overflow-hidden rounded-3xl transition-shadow duration-300 ${isOpen ? 'shadow-glow' : 'shadow-glass'}`} data-id="element-241" data-mp="1e0t2yh58unux">
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left" data-id="element-242" data-mp="2pdlw9wdonkd3">
                  <span className="font-display text-base font-semibold text-navy" data-id="element-243" data-mp="1c5t0mjx2641u">
                    {faq.q}
                  </span>
                  <motion.span animate={{
                rotate: isOpen ? 45 : 0
              }} transition={{
                duration: 0.3
              }} className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${isOpen ? 'bg-royal text-white' : 'bg-sky text-royal'}`} data-id="element-244" data-mp="1g5tqd0ply1o7">
                    <PlusIcon className="h-4 w-4" data-id="element-245" data-mp="x9288ulsxslq" />
                  </motion.span>
                </button>
                <AnimatePresence initial={false} data-id="element-246" data-mp="puuoox6fy4u">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.4,
                ease: [0.22, 1, 0.36, 1]
              }} data-id="element-247" data-mp="4qwo2p4exfyw">
                      <p className="px-6 pb-6 text-sm leading-relaxed text-slate" data-id="element-248" data-mp="k5y8ttrblf2w">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </Reveal>;
      })}
      </div>
    </section>;
}